// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamFilter_wrapper__1P9Ys"};